import { MyHttpClient } from '../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./http-client.service";
var CaptainComplaintsService = /** @class */ (function () {
    function CaptainComplaintsService(http) {
        this.http = http;
        this.server = environment.server;
    }
    CaptainComplaintsService.prototype.fetchComplaintsByCustomer = function (captainId) {
        var fetchComplaintsByCustomerUrl = this.server + "/api/svo/captain/" + captainId + "/complaintsbycustomer";
        return this.http.get(fetchComplaintsByCustomerUrl).pipe(catchError(this.handleError));
    };
    CaptainComplaintsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        return throwError(error);
    };
    CaptainComplaintsService.ngInjectableDef = i0.defineInjectable({ factory: function CaptainComplaintsService_Factory() { return new CaptainComplaintsService(i0.inject(i1.MyHttpClient)); }, token: CaptainComplaintsService, providedIn: "root" });
    return CaptainComplaintsService;
}());
export { CaptainComplaintsService };
